import { render, staticRenderFns } from "./OurPhilosophyCard.vue?vue&type=template&id=5c29ecc6&scoped=true&"
import script from "./OurPhilosophyCard.vue?vue&type=script&lang=js&"
export * from "./OurPhilosophyCard.vue?vue&type=script&lang=js&"
import style0 from "./OurPhilosophyCard.vue?vue&type=style&index=0&id=5c29ecc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c29ecc6",
  null
  
)

export default component.exports